<div class="modal">
  <div class="close-link" *ngIf="!isUploading">
    <span class="close" mat-dialog-close></span>
  </div>
  <h1 class="modal__title">{{ 'pages.tables.modal.settings' | translate }}</h1>

  <form class="modal__form" novalidated [formGroup]="editTableForm">
    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.name' | translate }}</mat-label>
      <input matInput appFormInputTrim formControlName="name">
      <mat-error *ngIf="editTableForm.controls.name.touched && editTableForm.controls.name.invalid">
        <span *ngIf="editTableForm.controls.name.errors?.required">
          {{ 'pages.tables.modal.mandatoryField' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.number' | translate }}</mat-label>
      <input matInput type="text" inputmode="numeric" appFormInputTrim formControlName="number">
      <mat-error *ngIf="editTableForm.controls.number.touched && editTableForm.controls.number.invalid">
        <span *ngIf="editTableForm.controls.number.errors?.pattern || editTableForm.controls.number.errors?.min">
          {{ 'pages.tables.modal.positiveNumber' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.notes' | translate }}</mat-label>
      <input matInput appFormInputTrim formControlName="description">
    </mat-form-field>

    <div class="modal__buttons-wrapper">
      <div class="field bill-qr-upload" *ngIf="!isWaiter" (click)="$event.stopPropagation()">
        <mat-label class="label">{{ 'pages.tables.content.qr' | translate }}</mat-label>
        <app-form-file-upload
          appDragAndDropFiles
          [previewUrl] = "this.invoiceQRCodeUrl"
          id="qr-code-image-{{ tableData.id }}"
          formControlName="QRCodeFile"
          accept="image/jpg, image/png"
          (change)="onQrFileChange($event)"
        >
          {{ 'formFilUpload.dragAndDrop' | translate }}
        </app-form-file-upload>
      </div>
    </div>
    <button
      class="dwall-device-id"
      *ngIf="tableData.dwallDeviceId"
      type="button"
      [matTooltip]="'pages.tables.modal.copyDwallDeviceId' | translate"
      (click)="copyDwallDeviceId()"
    >
      <span class="dwall-device-id__content">
        <span class="dwall-device-id__label">{{ 'pages.tables.modal.dwallDeviceId' | translate }}</span>
        <span class="dwall-device-id__value">{{ tableData.dwallDeviceId }}</span>
      </span>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M17.5 14H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v1.5M5 10h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7c0-1.1.9-2 2-2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="modal__buttons-wrapper">
      <button class="table-action"
              *ngIf="tableData.deviceUuid !== null || tableData.dwallDeviceId !== null"
              mat-stroked-button
              (click)="unlinkDevice()">
        {{ 'pages.tables.content.unlinkDevice' | translate }}
      </button>
      <button *ngIf="tableData.deviceUuid === null && tableData.dwallDeviceId === null"
              type="button"
              mat-stroked-button
              (click)="linkDevice()">
        {{ 'pages.tables.content.linkDevice' | translate }}
      </button>

      <button class="table-action"
        *ngIf="tableData.online && tableData.deviceUuid !== null"
        mat-stroked-button
        color="warn"
        (click)="turnOffTables()">
        {{ 'pages.tables.actions.turnOff' | translate }}
      </button>
    </div>

    <mat-dialog-actions class="mat-dialog-actions menu">
        <button
          class="btn btn__primary"
          type="submit"
          [disabled]="!isFormChanged || editTableForm.invalid || isUploading"
          (click)="editCurrentTable()"
        >{{ 'pages.tables.content.save' | translate }}
        </button>

        <button
          class="btn btn__warning"
          [disabled]="isUploading"
          (click)="deleteCurrentTable()"
        >{{ 'pages.tables.content.deleteTable' | translate }}
        </button>
    </mat-dialog-actions>
  </form>
</div>
